import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Header_Home from "../Component/Header_Home";
import Header from "../Component/Header";
import "../../App.css";
import "react-datepicker/dist/react-datepicker.css";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import "../RoleMaintenance/RoleMaintenance-styles.css";
import Skeleton from "react-loading-skeleton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import { TablePagination } from "@material-ui/core";
import "moment/locale/th";
import moment from "moment";
import CircularProgress from "@mui/material/CircularProgress";
import { Modal, Col, Button } from "react-bootstrap";
import successGif from "../../images/successGiff.gif";
import remove from "../../images/remove.png";
import {
  getMenuSettingAPI,
  getRoleMaintenanceAPI,
  saveRole,
  updateRole,
  saveMenuSetting,
} from "./RoleMaintenanceService/RoleMaintenanceService";
import debounce from "lodash.debounce";

const RoleMaintenance = () => {
  const theme = createTheme({
    components: {
      MuiTableHead: {
        styleOverrides: {
          root: {
            // backgroundColor: "#FFA500",
          },
        },
      },
    },
  });

  useEffect((date) => {
    // getConvertFormat(date)
  }, []);

  const style = {
    py: 0,
    width: "100%",
    maxWidth: 360,
    borderRadius: 2,
    border: "1px solid",
    borderColor: "divider",
    backgroundColor: "background.paper",
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [loading, setLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [editData, setEditData] = useState({
    roleName: "",
    roleCode: "",
    flagActive: "N",
  });

  const [step, setStep] = useState(1);
  const [rowMenuSetting, setRowMenuSetting] = useState([]);
  const [rowRoleMaintenance, setRoleMaintenance] = useState([]);
  const [LoadingContent, setLoadingContent] = useState(false);
  const [roleName, setRoleName] = useState("");
  const [roleCode, setRoleCode] = useState("");
  const [flagActive, setFlagActive] = useState("N");
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedRoleCode, setSelectedRoleCode] = useState("");
  const [changedItems, setChangedItems] = useState([]);
  const [toggledItems, setToggledItems] = useState([]);
  const [showSubmitModal, setShowSubmitModal] = useState(false);
  const [submitStatus, setSubmitStatus] = useState("");

  useEffect(() => {
    const debounced = debounce(() => {
      getRoleMaintenance(roleName);
    }, 300);

    debounced();

    return () => debounced.cancel();
  }, [roleName]);

  const handleChangeRoleName = (e) => {
    setRoleName(e.target.value);
  };
  const handleChangeRoleCode = (e) => {
    setRoleCode(e.target.value);
  };
  const handleChangeFlagActive = (e) => {
    setFlagActive(e.target.value);
  };

    const toggleSubmitModalOpen = () => {
    setShowSubmitModal(true);
  };

  const toggleSubmitModalClose = () => {
    setShowSubmitModal(false);
  };

  const clear = () => {
    setRoleName("");
    getRoleMaintenance(roleName);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleAdd = () => {
    setEditData({
      roleName: "",
      roleCode: "",
      flagActive: "N",
    });
    setIsEditMode(false);
    setOpenModal(true);
  };

  const handleSetting = (item) => {
    setEditData(item);
    setStep(2);
  };

  const handleAccessToggle = (index) => {
    const updated = [...rowMenuSetting];
    const oldAccess = updated[index].access;
  
    // Toggle access
    updated[index].access =
      oldAccess === true || oldAccess === "true" ? "false" : "true";
  
    const roleCode = selectedRoleCode;
    const roleMenu = updated[index].pmdId;
    const access = updated[index].access;
    console.log("updated: " , updated);
    setRowMenuSetting(updated);
  
    setToggledItems((prev) => {
      const exists = prev.some((item) => item.pmdId === roleMenu);
  
      if (access === "true") {
        // ถ้ายังไม่มีให้เพิ่ม
        if (!exists) {
          return [...prev, { roleCode, roleMenu, access }];
        }
        // ถ้ามีอยู่แล้วก็อาจอัปเดต access ได้ ถ้าต้องการ (optional)
        return prev.map((item) =>
          item.roleMenu === roleMenu ? { ...item, access } : item
        );
      } else {
        // ลบออกเมื่อ uncheck
        return prev.filter((item) => item.roleMenu !== roleMenu);
      }
    });
  
    console.log("Toggled:", { roleCode, roleMenu, access });
  };

  useEffect(() => {
    console.log("Current toggled items:", toggledItems);
  }, [toggledItems]);
  

  // const handleAccessToggle = (index) => {
  //   const updated = [...rowMenuSetting];
  //   updated[index].access = updated[index].access === "true" ? "false" : "true";
  //   setRowMenuSetting(updated);
  //   console.log(updated);
  // };

  const getMenuSetting = async (roleCode) => {
    setSelectedRoleCode(roleCode); // ✅ บันทึกค่าที่จะใช้ตอน save
    console.log(roleCode);
    const result = await getMenuSettingAPI(roleCode);
    setRowMenuSetting(result.payload);
  };

  const getRoleMaintenance = async () => {
    setLoadingContent(true);

    const result = await getRoleMaintenanceAPI(roleName);
    setTimeout(() => {
      setPage(0);
      setRoleMaintenance(result.payload);
      console.log(result.payload);
      setLoadingContent(false);
    }, 1000);
  };

  useEffect(() => {
    getRoleMaintenance();
  }, []);

  const saveData = async () => {
    let result;
    try {
      if (isEditMode) {
        result = await updateRole(editData);
      } else {
        result = await saveRole(editData);
      }
      console.log(result.data);
      setOpenModal(false)
      getRoleMaintenance();
      setSubmitStatus("success");
      setTimeout(() => {
        toggleSubmitModalOpen();
      }, 300);
    } catch (error) {
      console.error("Error saving role:", error);
      setSubmitStatus("error");
      toggleSubmitModalOpen();
    }
  };

  const handleToggleFlag = () => {
    setEditData((prev) => ({
      ...prev,
      flagActive: prev.flagActive === "Y" ? "N" : "Y",
    }));
  };

  const saveDataMenuSetting = async () => {
    const editData = {
      RoleCode: selectedRoleCode,
      RoleMenu: rowMenuSetting
        .filter((item) => item.access === true || item.access === "true")
        .map((item) => ({
          ...item,
          access: "true", 
          pmdId: Number(item.pmdId), 
        })),
    };

    try {
      const result = await saveMenuSetting(editData)
      console.log(result.data)
      getMenuSetting(selectedRoleCode);
      setSubmitStatus("success")
      toggleSubmitModalOpen();;
    } catch (error) {
      console.error("Error saving menu setting:", error);
      setSubmitStatus("error");
      toggleSubmitModalOpen();
    }
  };

  return (
    <div>
      <Header_Home />
      <Header title="Role Maintenance" />

      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <CircularProgress
            sx={{ animationDuration: "550ms" }}
            color="inherit"
          />
        </div>
      )}

      <div className="table-page-container footer-space">
        {step === 1 ? (
          <div className="rounded-border bg-white p-2">
            <section
              className="filter-action-section"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                gap: "10px", // เผื่อไว้สำหรับ mobile หรือ flex-wrap
                flexWrap: "wrap", // เผื่อกรณีแคบ
              }}
            >
              {/* ปุ่มด้านซ้าย */}
              <button
                className="btn-fill-orange p-2 bold"
                style={{
                  fontSize: 16,
                  borderRadius: "14px",
                  boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
                }}
                onClick={() => handleAdd()}
              >
                Add
              </button>
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <input
                  type="text"
                  value={roleName}
                  placeholder="Search by name"
                  onChange={handleChangeRoleName}
                  style={{
                    padding: "8px 16px",
                    borderRadius: "16px",
                    border: "1px solid #ccc",
                    outline: "none",
                    fontSize: 16,
                  }}
                />
                <button
                  onClick={clear}
                  style={{
                    fontSize: 16,
                    fontWeight: "bold",
                    backgroundColor: "#f0f0f0",
                    borderRadius: "14px",
                    border: "none",
                    padding: "8px 20px",
                    boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
                    cursor: "pointer",
                  }}
                >
                  Clear
                </button>
              </div>
            </section>

            <br />
            {loading ? (
              <div className="p-4">
                <Skeleton variant="rectangular" height={70} />
                {[...Array(10)].map((_, i) => (
                  <Skeleton key={i} height={30} style={{ marginTop: 8 }} />
                ))}
              </div>
            ) : (
              <ThemeProvider theme={theme}>
                <TableContainer component={Paper}>
                  <Table aria-label="collapsible table">
                    <TableHead>
                      <TableRow style={{ backgroundColor: "#e7e7e786" }}>
                        <TableCell align="center" className="font-new">
                          Role Name
                        </TableCell>
                        <TableCell align="center" className="font-new">
                          Status
                        </TableCell>
                        <TableCell align="center" className="font-new">
                          Action
                        </TableCell>
                        <TableCell align="center" className="font-new">
                          Menu Setting
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rowRoleMaintenance.length > 0 ? (
                        rowRoleMaintenance
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((item, idx) => (
                            <TableRow key={idx}>
                              <TableCell align="center">
                                {item.roleName}
                              </TableCell>
                              <TableCell align="center">
                                {item.flagActive === "Y"
                                  ? "Active"
                                  : "Inactive"}
                              </TableCell>
                              <TableCell align="center">
                                <button
                                  className="btn-address-next bold"
                                  onClick={() => {
                                    setEditData({
                                      roleName: item.roleName,
                                      roleCode: item.roleCode,
                                      flagActive: item.flagActive,
                                    });
                                    setIsEditMode(true);
                                    setOpenModal(true);
                                  }}
                                  style={{
                                    minWidth: "10px",
                                    maxWidth: "100px",
                                    padding: "4px 8px",
                                  }}
                                >
                                  Edit
                                </button>
                              </TableCell>
                              <TableCell align="center">
                                <button
                                  className="btn-address-next bold"
                                  onClick={() => {
                                    setEditData({
                                      roleName: item.roleName,
                                      roleCode: item.roleCode,
                                      flagActive: item.flagActive,
                                    });
                                    setStep(2);
                                    getMenuSetting(item.roleCode);
                                  }}
                                  style={{
                                    minWidth: "10px",
                                    maxWidth: "100px",
                                    padding: "4px 8px",
                                  }}
                                >
                                  Setting
                                </button>
                              </TableCell>
                            </TableRow>
                          ))
                      ) : (
                        <TableRow>
                          <TableCell align="center" colSpan={7}>
                            <span className="font-new">ไม่พบข้อมูล</span>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={rowRoleMaintenance.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </TableContainer>
              </ThemeProvider>
            )}
            <Modal
              show={openModal}
              onHide={() => setOpenModal(false)}
              centered
              size="lg" // ขยายขนาด modal
            >
              <Modal.Header>
                <Modal.Title style={{ fontWeight: "bold" }}>
                  Add Role
                </Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <div style={{ padding: "0 20px" }}>
                  {/* Role Name */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "16px",
                      gap: "20px",
                    }}
                  >
                    <label style={{ fontWeight: "bold", width: "120px" }}>
                      Role name
                    </label>
                    <input
                      type="text"
                      placeholder="Role name"
                      style={{
                        flex: 1,
                        padding: "10px 16px",
                        borderRadius: "30px",
                        border: "1px solid #ccc",
                      }}
                      value={editData.roleName}
                      onChange={(e) =>
                        setEditData({ ...editData, roleName: e.target.value })
                      }
                    />
                  </div>

                  {/* Role Code */}
                  {!isEditMode && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "16px",
                        gap: "20px",
                      }}
                    >
                      <label style={{ fontWeight: "bold", width: "120px" }}>
                        Role code
                      </label>
                      <input
                        type="text"
                        placeholder="Role code"
                        style={{
                          flex: 1,
                          padding: "10px 16px",
                          borderRadius: "30px",
                          border: "1px solid #ccc",
                        }}
                        value={editData.roleCode}
                        onChange={(e) =>
                          setEditData({ ...editData, roleCode: e.target.value })
                        }
                      />
                    </div>
                  )}

                  {/* Flag active */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                      marginBottom: "16px",
                    }}
                  >
                    <label
                      style={{
                        fontWeight: "bold",
                        fontSize: "16px",
                        width: "120px",
                      }}
                    >
                      Flag active
                    </label>
                    <label className="toggle-switch">
                      <input
                        type="checkbox"
                        checked={editData.flagActive === "Y"}
                        onChange={handleToggleFlag}
                        value={flagActive}
                      />
                      <span className="slider2"></span>
                    </label>
                  </div>
                </div>
              </Modal.Body>

              <Modal.Footer style={{ justifyContent: "center" }}>
                <button
                  onClick={() => saveData()}
                  style={{
                    backgroundColor: "#ff5e3a",
                    color: "#fff",
                    fontWeight: "bold",
                    border: "none",
                    padding: "8px 24px",
                    borderRadius: "12px",
                    minWidth: "100px",
                    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
                    marginRight: "10px",
                  }}
                >
                  บันทึก
                </button>
                <button
                  onClick={() => setOpenModal(false)}
                  style={{
                    backgroundColor: "rgba(187, 186, 185, 0.5)",
                    color: "#000",
                    fontWeight: "bold",
                    border: "none",
                    padding: "8px 24px",
                    borderRadius: "12px",
                    minWidth: "100px",
                    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  ยกเลิก
                </button>
              </Modal.Footer>
            </Modal>
            <Modal show={showSubmitModal} onHide={toggleSubmitModalClose} centered>
          <Modal.Header closeButton>
            <h5
              className="bold"
              style={{
                color: submitStatus === "success" ? "#28a745" : "#dc3545",
              }}
            >
              Submit
            </h5>
          </Modal.Header>
          <hr
            style={{
              margin: "0px 10px 0px 5px",
              border: "solid 2px",
              borderTop: 0.1,
              color: submitStatus === "success" ? "#28a745" : "#dc3545",
            }}
          />
          <Modal.Body>
            <img
              src={submitStatus === "success" ? successGif : remove} // ตั้ง errorGif ให้เหมาะสม
              alt={"submitStatusGif"}
              style={{
                height: "auto",
                marginLeft: "35%",
                width: "30%",
              }}
            />
            <li
              className="body-list-group"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Col
                xl={12}
                md={12}
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                }}
              >
                <h3 className="bold">
                  {submitStatus === "success"
                    ? "ระบบบันทึกข้อมูลเรียบร้อย"
                    : "ไม่สามารถบันทึกข้อมูลได้"}
                </h3>
              </Col>
            </li>
            <section className="filter-action-section">
              <button
                style={{ fontSize: 18 }}
                onClick={toggleSubmitModalClose}
                className="btn-fill-orange  p-2 bold"
              >
                ตกลง
              </button>
            </section>
          </Modal.Body>
        </Modal>
          </div>
        ) : (
          <div className="rounded-border bg-white p-4">
            <h3 style={{ fontWeight: "bold", padding: "10px 0" }}>
              Menu Setting :{" "}
              <span style={{ color: "black" }}>{editData.roleName}</span>
            </h3>

            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow style={{ backgroundColor: "#e7e7e786" }}>
                    <TableCell align="left">
                      <b>Menu Name</b>
                    </TableCell>
                    <TableCell align="center">
                      <b>Url</b>
                    </TableCell>
                    <TableCell align="center">
                      <b>Access</b>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rowMenuSetting?.map((item, idx) => (
                    <TableRow key={idx}>
                      <TableCell align="left">{item.menuName}</TableCell>
                      <TableCell align="left">{item.urlLink}</TableCell>
                      <TableCell align="center">
                        <Checkbox
                          type="checkbox"
                          checked={
                            item.access === true || item.access === "true"
                          }
                          onChange={() => handleAccessToggle(idx)}
                          // sx={{ color: "#ff5e3a" }}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={rowMenuSetting?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TableContainer>
            <Modal show={showSubmitModal} onHide={toggleSubmitModalClose} centered>
          <Modal.Header closeButton>
            <h5
              className="bold"
              style={{
                color: submitStatus === "success" ? "#28a745" : "#dc3545",
              }}
            >
              Submit
            </h5>
          </Modal.Header>
          <hr
            style={{
              margin: "0px 10px 0px 5px",
              border: "solid 2px",
              borderTop: 0.1,
              color: submitStatus === "success" ? "#28a745" : "#dc3545",
            }}
          />
          <Modal.Body>
            <img
              src={submitStatus === "success" ? successGif : remove} // ตั้ง errorGif ให้เหมาะสม
              alt={"submitStatusGif"}
              style={{
                height: "auto",
                marginLeft: "35%",
                width: "30%",
              }}
            />
            <li
              className="body-list-group"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Col
                xl={12}
                md={12}
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                }}
              >
                <h3 className="bold">
                  {submitStatus === "success"
                    ? "ระบบบันทึกข้อมูลเรียบร้อย"
                    : "ไม่สามารถบันทึกข้อมูลได้"}
                </h3>
              </Col>
            </li>
            <section className="filter-action-section">
              <button
                style={{ fontSize: 18 }}
                onClick={toggleSubmitModalClose}
                className="btn-fill-orange  p-2 bold"
              >
                ตกลง
              </button>
            </section>
          </Modal.Body>
        </Modal>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
                gap: "10px",
              }}
            >
              <button
                onClick={() => saveDataMenuSetting()}
                style={{
                  backgroundColor: "#ff5e3a",
                  color: "#fff",
                  fontWeight: "bold",
                  border: "none",
                  padding: "8px 24px",
                  borderRadius: "12px",
                  minWidth: "100px",
                  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
                }}
              >
                บันทึก
              </button>
              <button
                onClick={() => setStep(1)}
                style={{
                  backgroundColor: "rgba(187, 186, 185, 0.5)",
                  color: "#000",
                  fontWeight: "bold",
                  border: "none",
                  padding: "8px 24px",
                  borderRadius: "12px",
                  minWidth: "100px",
                  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
                }}
              >
                กลับ
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RoleMaintenance;
